import React from "react";

const About: React.FC = () => {
  return (
    <div>
      {/* About Banner Section */}
      <section className="about_banner_section" id="about_banner">
        <div className="common_banner_section" id="common_banner_sec">
          <div className="page_navegation_area">
            <div className="container">
              <div className="page_navegation font_two">
                <p>
                  <a href="/">Home</a> /{" "}
                  <span className="active fw_700">About Us</span>
                </p>
              </div>
            </div>
          </div>
          <div className="about_sec">
            <div className="container">
              <div className="about_area">
                <div className="row align-items-center">
                  <div className="col-xxl-6">
                    <div className="about_content d-flex flex-column font_two">
                      <h1 className="font_one heading_text_2">
                        About Digi Cartt
                      </h1>
                      <div className="about_info d-flex flex-column">
                        <p className="d-sm-block" style={{ textAlign: "justify" }}>
                          Digi Cartt is a curated digital art marketplace for
                          modern creatives, offering premium downloads and
                          gallery‑grade prints across styles like surreal
                          double‑exposures, abstracts, portraits, and limited
                          editions, all delivered instantly after checkout with
                          clear, flexible licensing. It focuses on print‑ready
                          quality, consistent color profiles, and detailed
                          size/DPI guides so every piece looks outstanding on
                          screen or on wall.
                        </p>
                        <div className="about_img_inner_box d-xxl-none">
                          <div className="about_img_aera position-relative overflow-hidden d-xxl-none">
                            <div className="about_img">
                              <img
                                src="/assets/images/home_about_img_1.png"
                                alt="about_img"
                              />
                            </div>
                            <div className="about_img">
                              <img
                                src="/assets/images/home_about_img_2.png"
                                alt="about_img"
                              />
                            </div>
                          </div>
                        </div>
                        <p className="d-sm-block d-none" style={{ textAlign: "justify" }}>
                          Built by designers for creators and collectors, Digi
                          Cartt pairs editorial curation with a smooth buying
                          experience—secure payments, lifetime access to past
                          purchases in the account, and optional museum‑quality
                          giclée prints on select works. Artists benefit from a
                          transparent creator program, portfolio curation,
                          analytics, and IP protection that keeps buyer files
                          clean while safeguarding original work.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-6 d-xxl-block d-none">
                    <div className="about_img_aera position-relative overflow-hidden">
                      <div className="about_img">
                        <img
                          src="/assets/images/home_about_img_1.png"
                          alt="about_img"
                        />
                      </div>
                      <div className="about_img">
                        <img
                          src="/assets/images/home_about_img_2.png"
                          alt="about_img"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Full Image Section */}
      <div className="img_full_section">
        <div className="img_full_sec">
          <div className="container">
            <div className="img_full_area">
              <img
                src="/assets/images/about_full_img.png"
                alt="about_full_img"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Center Textbox Section */}
      <div className="center_textbox_section">
        <div className="center_textbox_sec">
          <div className="container">
            <div className="center_textbox_area text-center">
              <div className="row">
                <div className="col-12">
                  <p className="heading_text_3" style={{ textAlign: "justify" }}>
                      Our Canvas Collection is designed for those who appreciate the texture
                      and presence of physical masterpieces. We bring you a selection of
                      exclusive hand-painted art and high-definition canvas prints that
                      capture every brushstroke and color nuance. From contemporary abstracts
                      to timeless classical scenes, each piece is meticulously crafted and
                      framed to provide a premium gallery-like experience in your home or
                      office. Simply choose the artwork that speaks to you, and we will handle
                      the rest delivering a stunning, ready-to-mount piece directly to your
                      doorstep with the utmost care.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Image Box Section */}
      <div className="img_box_section">
        <div className="img_box_sec">
          <div className="container">
            <div className="img_box_area">
              <div className="inner_img_box">
                <img src="/assets/images/img_box_1.png" alt="img_box" />
              </div>
              <div className="inner_img_box">
                <img src="/assets/images/img_box_2.png" alt="img_box" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Center Textbox Section */}
      <div className="center_textbox_section">
        <div className="center_textbox_sec">
          <div className="container">
            <div className="center_textbox_area text-center">
              <div className="row">
                <div className="col-12">
                  <p className="heading_text_3" style={{ textAlign: "justify" }}>
                      For the modern decorator and DIY enthusiast, we present DigiVision.
                      This category offers an extensive library of high-quality,
                      high-resolution digital art files available for instant download.
                      With DigiVision, you have the ultimate flexibility: once you
                      purchase your favorite design, you can print it at home, at a
                      local shop, or via any professional printing service. Whether you
                      want to mount it on a large feature wall, create a personalized
                      gallery grid, or print it on unique materials like metal or acrylic,
                      DigiVision empowers you to decorate your space exactly how you want it.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      {/* <NewsletterSubscription /> */}
    </div>
  );
};

export default About;
